import React, { useState } from "react";
import ReactQuill from "react-quill";
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import { createService } from "../../../../actions/Appointment/serviceAction";
import {
  Form,
  Input,
  Button,
  Drawer,
  message,
  DatePicker,
  Divider,
  Select,
  Col,
  Row,
} from "antd";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";

const { Option } = Select;

const CreateNewService = ({
  setReload,
  reload,
  createService,
  setUpdatelist,
}) => {
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  // const dispatch = useDispatch();

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
    form.resetFields();
  };

  const onFinish = (values) => {
     createService(values);
    setUpdatelist(false);
    message.success(values.name + " Has been added to Service");
    setVisible(false);
    form.resetFields();
  };

  return (
    <>
      <Button
        type="primary"
        onClick={showDrawer}
        style={{ marginBottom: "10px", float: "right" }}
      >
        <PlusOutlined /> Create New Service
      </Button>
      <Drawer
        title="Create New Service "
        width={720}
        onClose={onClose}
        visible={visible}
        bodyStyle={{ paddingBottom: 80 }}
      >
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Row gutter={16}>
            <Col span={16}>
              <Form.Item
                name="name"
                label="Service Name"
                rules={[
                  {
                    required: true,
                    message: "Please enter the name",
                  },
                ]}
              >
                <Input placeholder="Please enter the name" />
              </Form.Item>
            </Col>
            </Row>
            <Row gutter={24}>
            <Col span={24}>
            <Form.Item
            name="description"
            label="Description"
            rules={[
              {
                required: true,
                message: "Please enter the description",
              },
            ]}
          >
            {/* <Input.TextArea placeholder="Please enter the description" /> */}
            <ReactQuill theme="snow" preserveWhitespace={true}/>
          </Form.Item>
          </Col>
          </Row>

          <Form.Item>
            <Button onClick={onClose} style={{ marginRight: 8 }}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit">
              Create
            </Button>
          </Form.Item>
        </Form>
      </Drawer>
    </>
  );
};

export default connect(null, {
     createService,
})(CreateNewService);
